// extracted by mini-css-extract-plugin
module.exports = {"DbCompareDashboardCol":"DbCompareDashboardCol_WMlIl"};